import { render, staticRenderFns } from "./centerGoodsList.vue?vue&type=template&id=7dcc9506&scoped=true&"
import script from "./centerGoodsList.vue?vue&type=script&lang=js&"
export * from "./centerGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./centerGoodsList.vue?vue&type=style&index=0&id=7dcc9506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc9506",
  null
  
)

export default component.exports